import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../User/Home/homepage";
import UploadInfo from "../User/Home/form";
import Scanner from "../User/Scanner/qrcodescanner"

const MainCommon = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload-info" element={<UploadInfo />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route
          path="*"
          element={
            <div>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for does not exist.</p>
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default MainCommon;
